<template>
    <el-card>
        <div slot="header">
            <span>模板分组</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="add">新增</el-button>
        </div>
        <div style="height: calc(100vh - 160px)">
            <el-scrollbar style="height: 100%">
                <div v-for="group in groups" :key="group.id" class="item"
                     :class="group.id === active ? 'active' : ''" @click="click(group.id)">
                    {{group.name}}
                    <span class="tools" v-if="group.id > 0">
                        <el-button type="text" icon="el-icon-edit" size="small" @click.stop="edit(group)"></el-button>
                        <el-button type="text" icon="el-icon-delete" size="small" @click.stop="remove(group.id)"></el-button>
                    </span>
                </div>
            </el-scrollbar>
        </div>

        <el-dialog title="分组配置" :visible.sync="dialogFormVisible" width="500px">
            <el-form :model="form" :rules="rules" ref="form" :status-icon="true"
                     label-width="80px" label-position="left">
                <el-form-item label="业务" prop="code">
                    <Cascade ref="cascade" v-model="form.code"></Cascade>
                </el-form-item>
                <el-form-item label="组名" prop="name">
                    <el-input v-model="form.name" autocomplete="off" maxlength="20" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="分组选择" :visible.sync="dialogSelectVisible" width="500px">
            <el-select v-model="select" filterable placeholder="请选择分组" style="width: 400px">
              <template v-for="group in groups">
                <el-option v-if="group.id > -1" :key="group.id" :label="group.name" :value="group.id"></el-option>
              </template>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogSelectVisible = false">取 消</el-button>
                <el-button type="primary" @click="choose">确 定</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
    import Cascade from '@/components/Cascade'

    export default {
        components: {
            Cascade
        },
        props: ["type", "code"],
        data() {
            return {
                groups: [],
                active: 0,
                dialogFormVisible: false,
                form: {},
                rules: {
                    name: [
                        {required: true, message: "请填写组名"}
                    ],
                    code: [
                        {required: true, min: 6, message: "请选择业务"}
                    ]
                },
                dialogSelectVisible: false,
                select: 0
            }
        },
        beforeMount() {
            this.load();
        },
        watch: {
            code() {
                this.load();
            }
        },
        methods: {
            load() {
                let rules = [
                    {field: "type", value: this.type}
                ];

                if (this.code) {
                    rules.push({field: "code", op: "beginwith", value: this.code})
                }

                this.$axios.post("/group/list", {
                    rules: rules
                }).then(data => {
                    this.groups = [{id:-1, name: "全部"},{id:0, name: "默认"}].concat(data);
                })
            },
            click(groupId) {
                this.active = groupId;
                this.$emit("click", groupId);
            },
            add() {
                this.dialogFormVisible = true;
                this.$nextTick(() => {
                    this.form = {
                        type: this.type,
                        code: this.$root.isAdmin ? this.code : this.$root.code
                    };
                    this.$refs.form.resetFields();
                });
            },
            edit(group) {
                this.dialogFormVisible = true;
                this.$nextTick(() => {
                    this.form = JSON.parse(JSON.stringify(group));
                });
            },
            submit() {
                let url = this.form.id > 0 ? "/group/edit" : "/group/save";
                this.$utils.submit(this.$refs.form, url, this.form, () => {
                    this.dialogFormVisible = false;
                    this.load();
                });
            },
            remove(groupId) {
                this.$confirm('此操作将永久删除该分组, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.post("/group/remove/" + groupId).then(() => {
                        this.click(0);
                        this.load();
                    })
                })
            },
            showSelect() {
                this.dialogSelectVisible = true;
                this.select = 0;
            },
            choose() {
                this.dialogSelectVisible = false;
                this.$emit("select", this.select);
            }
        }
    }
</script>

<style scoped>
    .item {
        line-height: 30px;
        position: relative;
        font-size: 13px;
        cursor: pointer;
    }

    .item.active {
        font-weight: bold;
        color: #409EFF;
    }

    .item .tools {
        position: absolute;
        right: 0;
    }

    .item .tools button {
        margin-left: 5px;
    }
</style>